import { stegaClean } from "next-sanity";

// TODO: Använd riktiga alt-texter även för dessa
// (Structural param type so both the hand-written postAuthor shape and the
// Sanity TypeGen generated author shape - with `| null` fields - are accepted.)
export const getAuthorImage = (
  author: { photoUrl?: string | null; title?: string | null },
  photoTranslation: string,
) => {
  let image = "";
  let alt = "";
  if (author.photoUrl) {
    image = author.photoUrl;
    alt = `${author.title}, ${photoTranslation}.`;
  }
  return { image, alt: alt || "" };
};

/**
 * Cleans string values from Sanity by removing zero-width Unicode characters
 * that can cause string matching issues, especially in draft mode.
 * @param value - The string value to clean
 * @returns A cleaned string with zero-width characters removed
 */
export function cleanSanityString(value: string | null | undefined): string {
  if (!value) return "";

  return (
    stegaClean(value)
      .toString()
      // Remove all zero-width characters (comprehensive regex)
      .replace(/[\u200B-\u200D\uFEFF\u00AD\u2060-\u206F\u180E]/g, "")
      .trim()
  );
}

/**
 * Cleans headline/title strings from Sanity.
 *
 * In addition to {@link cleanSanityString}, it also:
 * - Removes accidental "word splits" where a word is separated by multiple spaces
 *   (e.g. "tillgäng   lighets" → "tillgänglighets")
 * - Collapses remaining whitespace runs to a single space
 */
export function cleanSanityHeadline(value: string | undefined): string {
  const cleaned = cleanSanityString(value);

  return (
    cleaned
      // If multiple spaces ended up inside a word, join it back together.
      // Using unicode letter class to support non-ASCII (e.g. å/ä/ö).
      .replace(/(\p{L})\s{2,}(\p{L})/gu, "$1$2")
      // Normalize any remaining whitespace runs.
      .replace(/\s+/g, " ")
      .trim()
  );
}

/**
 * Cleans orientation values from Sanity by removing zero-width Unicode characters
 * that can cause string matching issues, especially in draft mode.
 * @param value - The orientation value to clean
 * @returns A normalized orientation value ("left" | "right" | "center" | "none")
 */
export function cleanOrientation(
  value: string | undefined,
): "left" | "right" | "center" | "none" {
  const cleaned = cleanSanityString(value).toLowerCase();

  // Only return valid values
  if (
    cleaned === "left" ||
    cleaned === "right" ||
    cleaned === "center" ||
    cleaned === "none"
  ) {
    return cleaned;
  }
  return "center";
}
